import { InvalidFieldError } from '../errors';
export class NumberminMaxFieldValidation {
    constructor(field, min, max) {
        this.field = field;
        this.min = min;
        this.max = max;
    }
    validate(input) {
        const value = input[this.field];
        if (typeof value !== 'number') {
            return new InvalidFieldError("The field isn't a number");
        }
        if ((this.min !== undefined && value < this.min) || (this.max !== undefined && value > this.max)) {
            return new InvalidFieldError("Min or max value isn't valid");
        }
        return null;
    }
}
